import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
import { computed, defineComponent, reactive, ref } from "vue";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import { isNumber } from "lodash";
import ListHead from "./cpns/list-head.vue";
import SongerList from "./cpns/songer-list.vue";
export default defineComponent({
  name: "ArtistList",
  setup: function setup() {
    var state = useState("Artist", ["songerList"]);
    var store = useStore(); //标签请求数据

    var tagInfo = reactive({
      type: -1,
      area: -1,
      initial: -1,
      limit: 42,
      offset: 0
    });
    store.dispatch("Artist/getArtistTag", tagInfo);
    var page = ref(1);
    var CHARCODE_A_UC = 65; //大写A

    /* 语种分类 */

    var languages = reactive([{
      id: -1,
      title: "全部"
    }, {
      id: 7,
      title: "华语"
    }, {
      id: 96,
      title: "欧美"
    }, {
      id: 8,
      title: "日本"
    }, {
      id: 16,
      title: "韩国"
    }, {
      id: 0,
      title: "其他"
    }]);
    /* 歌手分类 */

    var songerSort = reactive([{
      id: -1,
      title: "全部"
    }, {
      id: 1,
      title: "男歌手"
    }, {
      id: 2,
      title: "女歌手"
    }, {
      id: 3,
      title: "乐队组合"
    }]);
    /* 筛选分类,26个英文字母，懒得一个个敲了 */

    var screen = computed(function () {
      return new Array(26).fill(null).map(function (v, i) {
        return String.fromCharCode(CHARCODE_A_UC + i);
      });
    });
    screen.value.unshift({
      id: -1,
      title: "热门"
    }); //在筛选数组最前添加

    screen.value.push({
      id: 0,
      title: "#"
    }); //在数组最后添加

    var leftTitle = reactive(["语种", "分类", "筛选"]);
    var rightTitle = reactive([languages, songerSort, screen.value]);
    /* 点击标签发送数据 */

    var tagClick = function tagClick(tagArr) {
      page.value = 1;
      tagInfo.offset = 0;
      tagInfo.type = tagArr[1];
      tagInfo.area = tagArr[0];
      tagInfo.initial = isNumber(tagArr[2]) ? tagArr[2] : tagArr[2].toLowerCase();
      /* 调用标签接口 */

      store.dispatch("Artist/getArtistTag", tagInfo);
    };
    /* 数字输入框改变事件 */


    var pageChange = function pageChange(page) {
      tagInfo.offset = (page - 1) * tagInfo.limit;
      store.dispatch("Artist/getArtistTag", tagInfo);
    };

    return _objectSpread(_objectSpread({}, state), {}, {
      page: page,
      leftTitle: leftTitle,
      rightTitle: rightTitle,
      tagClick: tagClick,
      pageChange: pageChange
    });
  },
  components: {
    ListHead: ListHead,
    SongerList: SongerList
  }
});